import { FunctionPermission } from '@/model/function-permission'
import { Menu } from '@/model/menu'
import {
  DataPermission,
  Role,
} from '@/model/role'

export type MenuFunctionPermission = FunctionPermission & { checked: boolean };

export interface DataType {
  key: number;
  menu: Partial<Menu>;
  dataPermission?: DataPermission;
  functionPermissions?: MenuFunctionPermission[];
  children?: DataType[];
}

export default function roleToTableData(
  menus: Menu[],
  functionPermissions: FunctionPermission[],
  role: Role,
): DataType[] {
  const menuFunctionPersmission: MenuFunctionPermission[] =
    functionPermissions.map((fp) => ({
      ...fp,
      checked: !!role.functionIds.find((id) => id === fp.id),
    }))

  const menuToDataType = (menu: Menu): DataType => {
    const roleMenu = role.menuPermissions.find((m) => m.menuId === menu.id)
    return {
      key: menu.id,
      menu,
      dataPermission: roleMenu?.dataPermission,
      functionPermissions: menuFunctionPersmission
        .filter((fp) => fp.menuId === menu.id)
        .sort((a, b) => a.id - b.id),
    }
  }

  const tableData: DataType[] = menus.map((menu) => {
    return menuToDataType(menu)
  })

  // make references
  for (const item of tableData) {
    if (item.menu.parentId) {
      const parentRow = tableData.find(
        (row) => row.menu.id === item.menu.parentId,
      )
      if (parentRow) {
        parentRow.children = parentRow.children || []
        parentRow.children.push(item)
      }
    }
  }

  const allMenu: DataType = {
    key: 0,
    menu: { name: 'All' },
    children: tableData.filter((item) => item.menu.parentId === 0),
  }

  return [allMenu]
}
